module.exports = __webpack_public_path__ + "static/media/Twyla.1231b6e7.jpeg";